import Vue from "vue";
import ApiService from "../../services/ApiService";
import { EventBus, EVENTS } from "../../services/EventBus";

const $ = require("jquery");

Vue.component("team-impact-widget", {
  props: {
    referenceType: {
      type: String,
      default: "item",
    },
    referenceId: {
      type: Number,
      required: true,
    },
    currentVariation: {
      type: Object,
      default: null,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    // Deaktiviert Abstimmungen (z.B. bei geschlossenen Gerüchten)
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      rating1: 0, // Schwächung
      rating2: 0, // Kaum Effekt
      rating3: 0, // Kaderbreite
      rating4: 0, // Klare Verstärkung
      rating5: 0, // Gamechanger
      total: 0,
      average: 0,
      userRating: null,
      isLoading: false,
      message: "",
      isLoggedIn: false,
    };
  },

  computed: {
    playerName() {
      if (!this.currentVariation) return '';
      
      // Verwende itemName Filter wenn verfügbar
      if (this.$options.filters && this.$options.filters.itemName) {
        return this.$options.filters.itemName(this.currentVariation) || '';
      }
      
      // Fallback: texts.name2
      return this.currentVariation.texts?.name2 || '';
    },
    
    clubName() {
      // Prüfe ob ein Slot für club-name vorhanden ist
      if (this.$slots['club-name']) {
        // Extrahiere Text aus dem Slot VNode
        const slotContent = this.$slots['club-name'];
        if (slotContent && slotContent.length > 0) {
          // Durchlaufe VNodes und sammle Text
          let text = '';
          const extractText = (vnode) => {
            if (vnode.text) {
              text += vnode.text;
            }
            if (vnode.children) {
              vnode.children.forEach(extractText);
            }
          };
          slotContent.forEach(extractText);
          return text.trim();
        }
      }
      
      // Fallback: Property ID 60 (to-club)
      if (this.currentVariation?.variationProperties) {
        for (let property of this.currentVariation.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 60);
            if (result?.values) {
              return result.values.value || '';
            }
          }
        }
      }
      return '';
    },
    
    questionText() {
      if (this.playerName && this.clubName) {
        return `Wie sehr verbessert ${this.playerName} ${this.clubName}?`;
      }
      return "Wie sehr verbessert der Spieler den Verein?";
    },
    
    ratingLabels() {
      return {
        1: { text: "Schwächung", icon: "fa-arrow-down", color: "danger" },
        2: { text: "Kaum Effekt", icon: "fa-minus", color: "warning" },
        3: { text: "Kaderbreite", icon: "fa-users", color: "info" },
        4: { text: "Klare Verstärkung", icon: "fa-arrow-up", color: "success" },
        5: { text: "Gamechanger", icon: "fa-star", color: "primary" },
      };
    },
  },

  mounted() {
    this.loadRatings();
    this.checkLoginStatus();
  },

  methods: {
    loadRatings() {
      this.isLoading = true;

      ApiService.get("/rest/fanliebling/team-impact", {
        referenceType: this.referenceType,
        referenceId: this.referenceId,
      })
        .done((response) => {
          const data = response.data || response;

          this.rating1 = parseInt(data.rating1) || 0;
          this.rating2 = parseInt(data.rating2) || 0;
          this.rating3 = parseInt(data.rating3) || 0;
          this.rating4 = parseInt(data.rating4) || 0;
          this.rating5 = parseInt(data.rating5) || 0;
          this.total = parseInt(data.total) || 0;
          this.average = parseFloat(data.average) || 0;
          this.userRating = data.userRating || null;
          this.isLoggedIn = data.isLoggedIn || false;
        })
        .fail((error) => {
          console.error("Team Impact Rating Load Error:", error);
        })
        .always(() => {
          this.isLoading = false;
        });
    },

    checkLoginStatus() {
      try {
        // SSR-safe: Only check on client
        if (typeof window === "undefined") {
          this.isLoggedIn = false;
          return;
        }
        
        // Versuche zu prüfen ob User eingeloggt ist
        if (typeof App !== "undefined" && App.isShopBuilder === false) {
          const contact = window.ceresStore?.state?.user?.data;
          this.isLoggedIn = contact && contact.id > 0;
        }
      } catch (e) {
        this.isLoggedIn = false;
      }
    },

    openLoginModal() {
      // Nutze den globalen Login-Modal aus Ceres
      if (typeof $ !== "undefined" && $("#login").length) {
        $("#login").modal("show");
      }
    },

    rate(ratingValue) {
      if (this.isLoading || this.disabled) {
        return;
      }

      // Prüfe Login-Status vor dem Rating
      if (!this.isLoggedIn) {
        this.openLoginModal();
        return;
      }

      this.isLoading = true;
      this.message = "";

      ApiService.post("/rest/fanliebling/team-impact", {
        rating: ratingValue,
        referenceType: this.referenceType,
        referenceId: this.referenceId,
        playerName: this.playerName,
        clubName: this.clubName,
      }, {
        supressNotifications: true
      })
        .done((response) => {
          // Debug: Log die komplette Response um die Struktur zu sehen
          console.log('Team Impact Response:', response);
          
          // ApiService kann die Response unterschiedlich wrappen
          // Versuche alle möglichen Strukturen
          const success = response.success || (response.data && response.data.success);
          const stats = response.stats || (response.data && response.data.stats) || {};
          const message = response.message || (response.data && response.data.message) || '';
          
          if (success) {
            // Update stats mit Vue reactivity
            this.$set(this, "rating1", parseInt(stats.rating1) || 0);
            this.$set(this, "rating2", parseInt(stats.rating2) || 0);
            this.$set(this, "rating3", parseInt(stats.rating3) || 0);
            this.$set(this, "rating4", parseInt(stats.rating4) || 0);
            this.$set(this, "rating5", parseInt(stats.rating5) || 0);
            this.$set(this, "total", parseInt(stats.total) || 0);
            this.$set(this, "average", parseFloat(stats.average) || 0);
            this.$set(this, "userRating", ratingValue);

            this.message = message || "Vielen Dank für deine Bewertung!";

            // Event auslösen für Badge-Update
            EventBus.$emit(EVENTS.INTERACTION_COMPLETED);

            // Nachricht nach 3 Sekunden ausblenden
            setTimeout(() => {
              this.message = "";
            }, 3000);
          } else {
            this.message = message || "Ein Fehler ist aufgetreten.";
          }
        })
        .fail((error) => {
          console.error("Team Impact Rating Error:", error);
          
          // Prüfe auf spezifische Fehlercodes
          if (error.status === 401 || error.status === 403) {
            this.message = "Bitte melde dich an, um zu bewerten.";
            this.openLoginModal();
          } else if (error.responseJSON && error.responseJSON.message) {
            this.message = error.responseJSON.message;
          } else {
            this.message = "Bewertung fehlgeschlagen. Bitte versuche es erneut.";
          }
          
          // Lade aktuelle Ratings neu
          setTimeout(() => {
            this.loadRatings();
          }, 1000);
        })
        .always(() => {
          this.isLoading = false;
        });
    },

    isRatingActive(ratingValue) {
      return this.userRating === ratingValue;
    },

    getRatingCount(ratingValue) {
      return this["rating" + ratingValue] || 0;
    },

    getRatingPercentage(ratingValue) {
      if (this.total === 0) return 0;
      const count = this.getRatingCount(ratingValue);
      return Math.round((count / this.total) * 100);
    },
    
    getAverageLabel() {
      if (this.average === 0) return "";
      
      // Prüfe ob es mehrere Ratings mit gleich vielen Stimmen gibt
      const counts = [
        { rating: 1, count: this.rating1 },
        { rating: 2, count: this.rating2 },
        { rating: 3, count: this.rating3 },
        { rating: 4, count: this.rating4 },
        { rating: 5, count: this.rating5 },
      ];
      
      // Finde die maximale Anzahl
      const maxCount = Math.max(...counts.map(c => c.count));
      
      // Finde alle Ratings mit der maximalen Anzahl
      const topRatings = counts.filter(c => c.count === maxCount && c.count > 0);
      
      // Wenn es mehrere Ratings mit gleich vielen Stimmen gibt
      if (topRatings.length > 1) {
        return 'Unentschlossen';
      }
      
      // Wenn es ein eindeutiges Maximum gibt
      if (topRatings.length === 1) {
        return this.ratingLabels[topRatings[0].rating].text;
      }
      
      // Fallback: Runde Durchschnitt
      const rounded = Math.round(this.average);
      const label = this.ratingLabels[rounded];
      return label ? label.text : "";
    },
    
    getAverageColor() {
      if (this.average === 0) return "secondary";
      
      // Prüfe ob es mehrere Ratings mit gleich vielen Stimmen gibt
      const counts = [
        { rating: 1, count: this.rating1 },
        { rating: 2, count: this.rating2 },
        { rating: 3, count: this.rating3 },
        { rating: 4, count: this.rating4 },
        { rating: 5, count: this.rating5 },
      ];
      
      const maxCount = Math.max(...counts.map(c => c.count));
      const topRatings = counts.filter(c => c.count === maxCount && c.count > 0);
      
      // Bei Unentschlossenheit: warning (orange)
      if (topRatings.length > 1) {
        return "warning";
      }
      
      // Bei eindeutigem Maximum: Farbe des Top-Ratings
      if (topRatings.length === 1) {
        return this.ratingLabels[topRatings[0].rating].color;
      }
      
      // Fallback
      const rounded = Math.round(this.average);
      const label = this.ratingLabels[rounded];
      return label ? label.color : "secondary";
    },
  },

  render: function(h) {
    const ratingButtons = [];
    
    // Erstelle 5 Rating-Buttons (von 5 bis 1, umgekehrte Reihenfolge für bessere UX)
    for (let i = 5; i >= 1; i--) {
      const label = this.ratingLabels[i];
      const isActive = this.isRatingActive(i);
      const count = this.getRatingCount(i);
      const percentage = this.getRatingPercentage(i);
      
      ratingButtons.push(
        h("button", {
          class: {
            "btn": true,
            "btn-sm": true,
            "team-impact-btn": true,
            [`btn-${label.color}`]: isActive,
            [`btn-outline-${label.color}`]: !isActive,
            "active": isActive,
          },
          style: {
            flex: "1",
            minWidth: "80px",
            padding: "12px 8px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "4px",
            position: "relative",
          },
          attrs: {
            disabled: this.isLoading || this.disabled,
            title: `${label.text} (${percentage}%)`,
          },
          on: {
            click: () => this.rate(i),
          },
        }, [
          h("i", { 
            class: `fa ${label.icon}`,
            style: { fontSize: "1.2rem" }
          }),
          h("span", { 
            style: { 
              fontSize: "0.75rem", 
              fontWeight: "600",
              textAlign: "center",
              lineHeight: "1.2"
            } 
          }, label.text),
          h("span", { 
            class: "badge badge-light",
            style: { 
              fontSize: "0.7rem",
              marginTop: "2px"
            } 
          }, `${count}`),
        ])
      );
    }
    
    return h("div", { class: "team-impact-widget" }, [
    //   this.showTitle
    //     ? h("div", { 
    //         class: "card-header text-white",
    //         style: {
    //           background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    //         }
    //       }, [
    //         h("h5", { 
    //           class: "mb-0",
    //           style: { fontSize: "0.95rem", fontWeight: "600" }
    //         }, "Team Impact"),
    //       ])
    //     : null,
        
      h("div", { class: "card-body p-0" }, [
        h("div", { 
          class: "mb-3 text-center font-weight-bold",          
        }, this.questionText),

        this.message
          ? h("div", { 
              class: this.message.includes("Fehler") || this.message.includes("fehlgeschlagen") 
                ? "alert alert-danger mb-2 py-2 px-3" 
                : "alert alert-success mb-2 py-2 px-3",
              style: { fontSize: "0.85rem" }
            }, this.message)
          : null,

        h("div", { 
          class: "team-impact-buttons d-flex gap-2 mb-3",
          style: {
            flexWrap: "wrap",
            justifyContent: "center"
          }
        }, ratingButtons),

        this.total > 0
          ? h("div", { 
              class: "team-impact-stats text-center pt-2",
              style: { 
                borderTop: "1px solid rgba(0,0,0,0.1)",
                fontSize: "0.85rem"
              }
            }, [
              h("div", { class: "d-flex justify-content-between align-items-center" }, [
                h("small", { class: "text-muted" }, `${this.total} ${this.total === 1 ? 'Bewertung' : 'Bewertungen'}`),
                this.average > 0
                  ? h("div", {
                      style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        gap: "2px"
                      }
                    }, [
                      h("span", { 
                        class: `badge badge-${this.getAverageColor()}`,
                        style: {
                          fontSize: "0.8rem",
                          fontWeight: "600"
                        }
                      }, this.getAverageLabel()),
                    ])
                  : null,
              ])
            ])
          : h("div", { 
              class: "text-center text-muted",
              style: { fontSize: "0.85rem" }
            }, [
              h("small", {}, "Sei der Erste, der bewertet!"),
            ]),

        this.isLoading
          ? h("div", { 
              class: "text-center mt-3" 
            }, [
              h("div", { 
                class: "spinner-border spinner-border-sm text-primary" 
              }, [
                h("span", { class: "sr-only" }, "Lädt..."),
              ])
            ])
          : null,
      ]),
    ]);
  },
});
